import React from 'react';

import { ListingStatus } from '@bb/domain/dist/types';
import { ListingLabelContextType, parseLabelFromString } from 'contexts';

type Status = ListingStatus | 'All';

interface Props {
  showSearch: boolean;
  minPrice?: number;
  maxPrice?: number;
  status?: Status;
  statuses: Status[];
  location?: string;
  locations: string[];
  avail?: string;
  availabilities: string[];
  search: (e: any) => void;
  handleChange: (key: string) => (event: any) => void;
  labelOverrideMap: ListingLabelContextType['labelOverrideMap'];
}

const SearchAdvancedComponent = (props: Props) => {
  const { statuses, handleChange, labelOverrideMap } = props;

  const getLabel = (str: string) =>
    labelOverrideMap[parseLabelFromString(str)]?.label || str;

  const isHidden = (str: string) =>
    labelOverrideMap[parseLabelFromString(str)]?.hidden || false;

  return (
    <div
      className={!props.showSearch ? 'collapse' : ''}
      style={{ marginTop: '21px' }}
    >
      <form className="row">
        <div className="form-group col-md-4">
          <label>Min Price</label>
          <input
            type="number"
            className="form-control"
            value={props.minPrice || ''}
            onChange={handleChange('minPrice')}
            placeholder="Min Price"
          />
        </div>
        <div className="form-group col-md-4">
          <label>Max Price</label>
          <input
            type="number"
            className="form-control"
            value={props.maxPrice || ''}
            onChange={handleChange('maxPrice')}
            placeholder="Max Price"
          />
        </div>
        <div className="form-group col-md-4">
          <label>{getLabel('Status')}</label>
          <select
            className="form-control"
            value={props.status}
            onChange={handleChange('status')}
          >
            {statuses.map(status => {
              if (isHidden(status)) return null;

              return (
                <option key={status} value={status}>
                  {getLabel(status)}
                </option>
              );
            })}
          </select>
        </div>
        <div className="form-group col-md-4">
          <label>Branch</label>
          <select
            className="form-control"
            value={props.location}
            onChange={handleChange('location')}
          >
            {props.locations.map(location => (
              <option key={location} value={location}>
                {location}
              </option>
            ))}
          </select>
        </div>
        <div className="form-group col-md-4">
          <label>{getLabel('Availability')}</label>
          <select
            className="form-control"
            value={props.avail}
            onChange={handleChange('avail')}
          >
            {props.availabilities.map(availability => (
              <option key={availability} value={availability}>
                {availability}
              </option>
            ))}
          </select>
        </div>
        <div className="form-group col-md-4">
          <button
            onClick={props.search}
            className="btn btn-primary"
            style={{ marginTop: '21px', width: '100%' }}
          >
            <i className="pe-7s-search fat" />
            &nbsp; Search
          </button>
        </div>
      </form>
    </div>
  );
};

export default SearchAdvancedComponent;
